import React from 'react';
import BNPLRegistration from '../../feature/bnpl';
import useStyles from './styles';

export default function BNPLPage() {
  const classes = useStyles();
  return (
    <div className={classes.contentContainer}>
      <BNPLRegistration />
    </div>
  );
}
